import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';

@Component({
    selector: 'data-field-view-name',
    templateUrl: './name.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewNameComponent extends FiDataFieldViewBase {
    get isNotEmpty() {
        return !!this.dataFieldObject.Name;
    }
}
